/**
 * 获取url参数
 * @param arg
 * @returns {[]}
 */
 export const getUrlParams = (arg) => {
    try {
        let url = arg || window.location.toString();
        let urlParams = [];
        let paramPos = url.lastIndexOf("?");
        if (paramPos !== -1) {
            let anchorPos = url.lastIndexOf("#")
            let paramAry = ((paramPos < anchorPos) ? url.substring(paramPos + 1, anchorPos) : url.substring(paramPos + 1)).split("&")
            for (let i = 0; i < paramAry.length; i++) {
                urlParams[paramAry[i].split("=")[0]] = unescape(paramAry[i].split("=")[1])
            }
        }
        return urlParams;
    }
    catch (e)
    {
        console.log(e);
        return {};
    }
}

export const stopZoom = () => {
    const keyCodeMap = {
      // 91: true, // command
      61: true,
      107: true, // 数字键盘 +
      109: true, // 数字键盘 -
      173: true, // 火狐 - 号
      187: true, // +
      189: true, // -
    };
    // 覆盖ctrl||command + ‘+’/‘-’
    document.onkeydown = function (event) {
      const e = event || window.event;
      const ctrlKey = e.ctrlKey || e.metaKey;
      if (ctrlKey && keyCodeMap[e.keyCode]) {
          e.preventDefault();
      } else if (e.detail) { // Firefox
          event.returnValue = false;
      }
    };
    // 覆盖鼠标滑动
    document.body.addEventListener('wheel', (e) => {
      if (e.ctrlKey) {
          if (e.deltaY < 0) {
              e.preventDefault();
              return false;
          }
          if (e.deltaY > 0) {
              e.preventDefault();
              return false;
          }
      }
    }, { passive: false });
}

export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 移动设备的关键词
    return /android|openharmony|harmonyos|iphone|ipad|ipod|ios|blackberry|iemobile|opera mini|mobile/i.test(userAgent);
};